<template>
  <div class="wrapper">
    <div
      v-for="(imagePath, index) in allImages"
      :key="index"
      class="image-wrapper"
    >
      <lookbook-image
        :path="imagePath"
      />
    </div>
    <div class="clear" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LookbookImage from './LookbookImage.vue'

export default {
  name: 'Main',
  components: { LookbookImage },
  data () {
    return {
      numberOfImages: 4,
      allImages: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions(['setSawEntrance', 'toggleShowNavbar']),
    goToPage (pathName) {
      this.toggleShowNavbar()
      this.$router.push({ name: pathName })
    },
    init () {
      this.allImages = [
        this.getImagePath(2),
        this.getImagePath(1),
        this.getImagePath(3),
        this.getImagePath(4)
      ]
    },
    randomIntFromInterval (min, max) { // min and max included
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    getImagePath (number) {
      return require('../assets/main/' + number + '.jpg')
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  height: 100%;
  width: 100%;
  padding-top: 60px;
}
.image-wrapper {
  position: relative;
    width: 100%;
    padding-bottom: calc(100% * 4/3);
    float: left;
    height: 0;
}

.clear {
  clear: left;
  width: 100%;
  height: 40px;
}

@media (min-width: 992px) {
  .wrapper {
    padding: 0;
  }
  .image-wrapper {
    position: relative;
    width: 50%;
    padding-bottom: calc(50% * 4/3);
    float: left;
    height: 0;
  }
}
</style>
